const pub = {
  "pub.whatsapp_default_msg": "Përshëndetje, jam i/e interesuar për një trajtim në Esteva Clinic.",
  "pub.error_title": "Ndodhi një gabim",
  "pub.error_message": "Ju lutemi ringarkoni faqen. Nëse problemi vazhdon, ju lutemi çaktivizoni përkthimin/shtesat e shfletuesit.",
  "pub.error_reload": "Ringarko faqen",
  "pub.pill_1": "Implante dentare Shqipëri",
  "pub.pill_2": "Transplant flokësh FUE",
  "pub.pill_3": "Rinoplastikë korrigjim hunde",
  "pub.pill_4": "Zmadhim gjiri",
  "pub.pill_5": "Lifting i fytyrës",
  "pub.pill_6": "Liposuksion",
  "pub.pill_7": "Veneer kurora zirkoni",
  "pub.pill_8": "Botox hialuron",
  "pub.pill_9": "Shtrëngim i barkut",
  "pub.pill_10": "Turizëm mjekësor Shqipëri",
  "pub.pill_11": "70% më lirë se Zvicra",
  "pub.pill_12": "Klinikë premium Tiranë",
  "pub.country_albania": "Shqipëri",
  "pub.opening_hours_default": "Hën–Pre: 08:00–20:00 | Sht: 09:00–16:00 | Die: Mbyllur",
  "pub.fkw_1": "Implante dentare Shqipëri",
  "pub.fkw_2": "Kurora zirkoni",
  "pub.fkw_3": "Veneer",
  "pub.fkw_4": "Zbardhim dhëmbësh",
  "pub.fkw_5": "Transplant flokësh FUE",
  "pub.fkw_6": "Zmadhim gjiri Shqipëri",
  "pub.fkw_7": "Rinoplastikë korrigjim hunde",
  "pub.fkw_8": "Botox Tiranë",
  "pub.fkw_9": "Liposuksion Shqipëri",
  "pub.fkw_10": "Lifting i fytyrës",
  "pub.fkw_11": "Shtrëngim i barkut",
  "pub.fkw_12": "Lifting i gjirit",
  "pub.fkw_13": "Zvogëlim gjiri",
  "pub.fkw_14": "Kirurgji e qepallave",
  "pub.fkw_15": "BBL Shqipëri",
  "pub.fkw_16": "Kirurgji intime",
  "pub.fkw_17": "Kirurgji plastike Shqipëri",
  "pub.fkw_18": "Kirurgji estetike Tiranë",
  "pub.fkw_19": "Turizëm mjekësor Shqipëri",
  "pub.fkw_20": "Turizëm dentar",
  "pub.fkw_21": "70% më lirë se Zvicra",
  "pub.fkw_22": "70% më lirë se Gjermania",
  "pub.fkw_23": "Dentist jashtë vendit",
  "pub.fkw_24": "Klinikë premium Tiranë",
  "pub.fkw_25": "Konsultë e parë falas",
};

export default pub;
